import React, { Suspense, lazy } from 'react';
import { Loading } from 'react-admin';

const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const Edit = lazy(() => import('./Edit'));

const Features = {
    name: 'features',
    list: (props) => (
        <Suspense fallback={<Loading />}>
            <List {...props} />
        </Suspense>
    ),
    create: (props) => (
        <Suspense fallback={<Loading />}>
            <Create {...props} />
        </Suspense>
    ),
    edit: (props) => (
        <Suspense fallback={<Loading />}>
            <Edit {...props} />
        </Suspense>
    ),
};

export default Features;
